import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject, EMPTY } from 'rxjs';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { DataApi } from 'app/Model/dataApi';
import { DataApiService } from '../../../services/data-api.service';
import { MenusFacadeService } from '../menus/menus-facade.service';
import { perfilInterface } from '../../../Model/Administracion/perfil.Interface';

@Injectable({
  providedIn: 'root'
})
export class PerfilesFacadeService {

  //Respuesta Acción
  private Action$ = new Subject<any>();
  public responseAction$: Observable<any> = this.Action$.asObservable();

  private Perfiles$ = new BehaviorSubject<perfilInterface[]>([]);
  public responsePerfiles$: Observable<perfilInterface[]> = this.Perfiles$.asObservable();

  private PerfilesSelect$ = new BehaviorSubject<perfilInterface[]>([]);
  public responsePerfilesSelect$: Observable<perfilInterface[]> = this.PerfilesSelect$.asObservable();

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private seleccionado$ = new BehaviorSubject<boolean>(false);
  public responseSeleccionado$: Observable<boolean> = this.seleccionado$.asObservable();


  private Error$ = new BehaviorSubject<any>({ hasError: true, recurso: '', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.Error$.asObservable();


  public perfiles: any[] =
    [{ IdPerfil: "BF155015-5FE4-4A0F-A705-1276E715B4F1", Perfil: "Estudiante", Observaciones: '', Activo: true },
      { IdPerfil: "854D2EBA-15B6-4EE9-99AC-8736C62C226F", Perfil: "Admin", Observaciones: '', Activo: true },
      { IdPerfil: "9F350366-061D-42F3-9FBF-880764C877B1", Perfil: "Recepcionista", Observaciones: '', Activo: true },
      { IdPerfil: "A97EE550-BC30-4D73-81AA-581C08316C0E", Perfil: "Desarrollador", Observaciones: '', Activo: true }
    ];

  constructor(private _mensajesHttp: MensajesHttpService,
    private _toast: ToastrServiceLocal, private _dataApi: DataApiService, private _menuService: MenusFacadeService) { }

  MostrarPerfiles(params: any) {
    this.Cargando$.next(true);
    const request$ = this._dataApi.PostDataApi('admin/v1/perfilMostrar', params, true).pipe(
      tap((result: DataApi | any) => {
        // console.log(result);
        this.Perfiles$.next(result.data.Table0);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar el perfil'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  MostrarComboboxPerfiles(params: any) {
    this.Cargando$.next(true);
    const request$ = this._dataApi.PostDataApi('admin/v1/perfilMostrar', params, true).pipe(
      tap((result: DataApi | any) => {

        this.PerfilesSelect$.next(result.data.Table0);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar el perfil'), errors: [] });
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  UsuariosPerfilesMostrar(params: any) {
    this.Cargando$.next(true);
    const request$ = this._dataApi.PostDataApi('admin/v1/usuario/perfilMostrar', params, true).pipe(
      tap((result: DataApi | any) => {
        this.Perfiles$.next(result.data.Table0);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Cargando$.next(false);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los perfiles del usuario', '');
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los perfiles del usuario'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  NuevoPerfil(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PostDataApi('admin/v1/perfil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();
        this.Action$.next(result);
        this._toast.mensajeSuccess('Se Inserto con exito el perfil', '');
        this.MostrarPerfiles({ opcion: 1 });

        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al insertar el perfil'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EditarPerfil(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PutDataApi('admin/v1/perfil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        if(result.hasError == false){
          this.MostrarPerfiles({ opcion: 1 });
        }
        this._toast.mensajeSuccess('Se actualizo con exito el perfil', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al actualizar el perfil'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EliminarPerfil(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');


    const request$ = this._dataApi.DeleteDataApi('admin/v1/perfil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se elimino con exito el perfil', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el perfil', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al eliminar el perfil'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  ActualizarPerfilMenu(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PutDataApi('admin/v1/menu/perfil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se actualizo con exito los permisos', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._menuService.accionRealizada = true;
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar los permisos', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'PUT', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al actualizar los permisos'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EliminarPerfilUsuario(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this._dataApi.PutDataApi('admin/v1/usuario/pefil', params, true).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se actualizo el estado con exito el perfil al usuario', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al actualizar el estado al perfil', '');
        this.Cargando$.next(false);

        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  perfilSeleccionado(){
    this.seleccionado$.next(true)
  }


}
